import { render, staticRenderFns } from "./seriesCategories.vue?vue&type=template&id=694c6ebe&"
import script from "./seriesCategories.vue?vue&type=script&lang=js&"
export * from "./seriesCategories.vue?vue&type=script&lang=js&"
import style0 from "./seriesCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "seriesCategories.vue"
export default component.exports